module.exports = __webpack_public_path__ + "static/media/crownperfumes.4d95dfa5.png";